const diacriticMap: Record<string, string[]> = {
  ä: ["a", "ae"],
  ö: ["o", "oe"],
  ü: ["u", "ue"],
  ß: ["s", "ss"],
};

export const normalizeDiacritics = (str: string): string[] => {
  if (!str) {
    return [""];
  }

  const word = str.toLowerCase();
  const variations = [word.normalize("NFD").replace(/[\u0300-\u036f]/g, "")];
  variations.push(word);

  for (const [char, replacements] of Object.entries(diacriticMap)) {
    if (word.includes(char)) {
      variations.push(...variations.flatMap((variant) => replacements.map((replacement) => variant.replaceAll(char, replacement))));
    }
  }

  return Array.from(new Set(variations));
};
